// 不需要校验token的路由白名单
export
const whiteList = [
  '/WechatDownload',
  '/ShareLive',
  '/courseDoor',
  '/todoLogin',
  '/ShareClass',
  '/ProductDynamic',
  '/ProductDynamicDetail',
  '/helpCenter',
  '/helpCenterDetail',
  '/helpCenterSearch',
  '/TeachingResearchPortalHomepage',
  '/feedBack',
  '/topicArticleDetailPage',
  '/themeInfoDetailPage',
  '/document_view',
  '/conferenceDetailPage',
  '/topicArticleDetailPage',
  '/resource_testpaper_detail',
  '/resource_homework_detail',
  '/resource_topic_detail',
];

export default {
  whiteList
};
